import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import MembersTable from './MembersTable';
import AddNewMemberDialog from './MemberDialogs/AddNewMemberDialog';
const MemberManagement: React.FC = () => {

  const [addNewMemberOpen, setAddNewMemberOpen] = useState(false);


  const handleAddNewMember = () => {
    setAddNewMemberOpen(!addNewMemberOpen);
  }

  return (
    <div className="ml-0 space-y-3">
        <div className="h-1/6 space-x-4">
          <Button variant="contained" color="primary" onClick={handleAddNewMember}>Add New Member</Button>
          <AddNewMemberDialog open={addNewMemberOpen} onClose={handleAddNewMember} />
        </div>

        <div className='h-5/6'>
          <Box>
            <MembersTable />
          </Box>
        </div>
      </div>
  );
};

export default MemberManagement;

